const variantElements = document.querySelectorAll('.variantItem');
const variantNameSpan = document.querySelector('.variant-name');
const galleryImage = document.querySelector('.gallery-image');

let originalVariantName = variantNameSpan?.textContent ?? '';
let originalGalleryImageSrcset = galleryImage?.srcset ?? '';
let originalGalleryImageSrc = galleryImage?.src ?? '';
let codeEnabled = true;
let hoverToken = 0; // used to know if we're still hovered on same thing

variantElements.forEach((variantElement) => {
  variantElement.addEventListener('mouseover', () => {
    if (!codeEnabled) return;

    hoverToken++; // new hover session
    const thisToken = hoverToken;

    // Update label
    if (variantNameSpan) {
      variantNameSpan.textContent = variantElement.getAttribute('data-name');
    }

    const variantImage = variantElement.querySelector('.variant-image');
    if (!variantImage) return;

    // LQ is the thumbnail src (already loaded)
    const lowSrc = variantImage.getAttribute('src');
    // HQ is what you were already using
    const highSrc = variantImage.getAttribute('data-fullsize-src');

    if (!galleryImage) return;

    // 1️⃣ Immediately show LQ on the main image only (no network)
    galleryImage.src = lowSrc;
    galleryImage.srcset = lowSrc;

    // 2️⃣ Preload HQ, then swap once it's ready — but only if still hovered
    const preload = new Image();
    preload.src = highSrc;
    preload.onload = () => {
      if (thisToken !== hoverToken) return; // user moved off / to another variant

      galleryImage.src = highSrc;
      galleryImage.srcset = highSrc;
    };
  });

  variantElement.addEventListener('mouseout', () => {
    if (!codeEnabled) return;

    hoverToken++; // invalidate any pending HQ swap

    // Restore text
    if (variantNameSpan) {
      variantNameSpan.textContent = originalVariantName;
    }

    // Restore original main gallery image
    if (galleryImage) {
      if (originalGalleryImageSrc) {
        galleryImage.src = originalGalleryImageSrc;
      }
      if (originalGalleryImageSrcset) {
        galleryImage.srcset = originalGalleryImageSrcset;
      }
    }
  });
});

const ratingBadge = document.querySelector('.rating-badge');
if (ratingBadge) {
  ratingBadge.addEventListener('click', () => {
    codeEnabled = false;
    setTimeout(() => {
      codeEnabled = true;
    }, 4000);
  });
}

/**
 * Scroll only the variants container. Temporarily freeze other horizontal
 * scrollers so WebKit scroll-snap doesn't cascade the scroll to them.
 */
function scrollVariantsContainerTo(container, targetElement, { behavior = 'auto' } = {}) {
  if (!container || !targetElement) return;

  const scrollPadding = parseFloat(getComputedStyle(container).scrollPaddingInlineStart) || 0;
  const nextLeft = Math.max(
    0,
    targetElement.getBoundingClientRect().left -
      container.getBoundingClientRect().left -
      scrollPadding +
      container.scrollLeft
  );

  if (Math.abs(container.scrollLeft - nextLeft) < 1) return;

  const siblings = [
    ...document.querySelectorAll(
      'scroll-carousel, .scroll-area, .product-list--carousel, .collection-list--carousel, .blog-post-list--carousel, .multi-column'
    ),
  ].filter((el) => el !== container && el.scrollWidth > el.clientWidth + 1);

  const frozen = siblings.map((el) => ({
    el,
    left: el.scrollLeft,
    snap: el.style.scrollSnapType,
  }));

  frozen.forEach(({ el }) => {
    el.style.scrollSnapType = 'none';
  });

  const previousSnap = container.style.scrollSnapType;
  container.style.scrollSnapType = 'none';

  const restoreSiblings = () => {
    frozen.forEach(({ el, left, snap }) => {
      if (Math.abs(el.scrollLeft - left) > 1) {
        el.scrollLeft = left;
      }
      if (snap) {
        el.style.scrollSnapType = snap;
      } else {
        el.style.removeProperty('scroll-snap-type');
      }
    });
  };

  if (behavior === 'smooth' && 'scrollTo' in container) {
    container.scrollTo({ left: nextLeft, behavior: 'smooth' });
  } else {
    container.scrollLeft = nextLeft;
  }

  const finish = () => {
    if (previousSnap) {
      container.style.scrollSnapType = previousSnap;
    } else {
      container.style.removeProperty('scroll-snap-type');
    }
    restoreSiblings();
  };

  requestAnimationFrame(() => {
    restoreSiblings();
    requestAnimationFrame(finish);
  });

  // WebKit can apply snap adjustments late — pin siblings again shortly after
  setTimeout(restoreSiblings, 50);
  setTimeout(restoreSiblings, 300);
}

document.addEventListener('DOMContentLoaded', () => {
  const targetElement = document.querySelector('.variants-by-tag .variantItem.current');
  const container = document.querySelector('.variants-by-tag .variant-picker__options');

  if (!targetElement || !container) return;

  const items = [...container.querySelectorAll('.variantItem')];
  const index = items.indexOf(targetElement);

  // Only auto-scroll when the selected variant is 5th or later
  if (index < 4) return;

  scrollVariantsContainerTo(container, targetElement);
});

window.scrollVariantsContainerTo = scrollVariantsContainerTo;
